import { createContext } from 'react';

export const UserTypeContext = createContext("");